// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--kf-oN";
export var stackedInfoWithImage = "styles-module--stackedInfoWithImage--XD1+H";
export var heading = "styles-module--heading--hClaQ";
export var description = "styles-module--description--66e0w";
export var image = "styles-module--image--hvHmI";